import PropTypes from "prop-types";
import ContentLoader from "react-content-loader";
import "./Placeholder.scss";

const Placeholder = () => (
    <div className="placeholder">
        <ContentLoader style={{ width: "100%" }}>
            <rect x="0" y="0" width="50" height="50" rx="8" />
            <rect x="70" y="10" width="30%" height="30" rx="8" />
            <rect x="70" y="50" width="20%" height="10" rx="8" />
            <rect x="70" y="70" width="25%" height="10" rx="8" />
            <rect x="0" y="130" width="50%" height="100" rx="8" />
            <rect x="0" y="250" width="50%" height="20" rx="8" />
            <rect x="0" y="280" width="70%" height="20" rx="8" />
            <rect x="0" y="310" width="30%" height="20" rx="8" />
            <rect x="0" y="370" width="80%" height="60" rx="8" />
            <rect x="0" y="440" width="40%" height="20" rx="8" />
            <rect x="0" y="470" width="80%" height="20" rx="8" />
            <rect x="0" y="500" width="50%" height="20" rx="8" />
        </ContentLoader>
    </div>
);

Placeholder.defaultProps = {};

Placeholder.propTypes = {};

Placeholder.PageHeader = () => (
    <div className="placeholder">
        <ContentLoader style={{ width: "100%", height: "57px" }}>
            <rect x="0" y="0" width="50" height="50" rx="8" />
            <rect x="70" y="15" width="30%" height="20" rx="8" />
            <rect x="70" y="50" width="20%" height="10" rx="8" />
            <rect x="70" y="70" width="25%" height="10" rx="8" />
        </ContentLoader>
    </div>
);

Placeholder.List = () => (
    <ContentLoader style={{ width: "100%" }}>
        <rect x="0" y="0" width="100%" height="20" rx="8" />
        <rect x="0" y="40" width="70%" height="20" rx="8" />
        <rect x="0" y="80" width="100%" height="20" rx="8" />
        <rect x="0" y="120" width="40%" height="20" rx="8" />
    </ContentLoader>
);

Placeholder.NarrowList = ({ linesNumber }) => {
    const height = 20;
    const rx = 8;
    return (
        <ContentLoader style={{ width: "100%" }}>
            {Array.from(new Array(linesNumber)).map((line, index) => (
                <rect
                    x="0"
                    y={height * index + rx * index}
                    width="100%"
                    height={height.toString()}
                    rx={rx.toString()}
                    key={index}
                />
            ))}
        </ContentLoader>
    );
};

Placeholder.NarrowList.propTypes = {
    linesNumber: PropTypes.number,
};

Placeholder.Widget = ({ size = 50 }) => (
    <ContentLoader style={{ width: "100%" }} height={size}>
        <rect x="0" y="0" width="100%" height={size} rx="8" />
    </ContentLoader>
);

Placeholder.Widget.defaultProps = {
    size: 50,
};

Placeholder.Widget.propTypes = {
    size: PropTypes.number,
};

export default Placeholder;
